import { jsx as s } from "react/jsx-runtime";
import { createContext as v, useMemo as w, useState as m, useEffect as d, useContext as k } from "react";
import { useGrowthBook as b, GrowthBook as F, GrowthBookProvider as E, useFeatureValue as x } from "@growthbook/growthbook-react";
import { uiEventEmitter as f } from "@made-people/grease-ui-events";
import { ManagedPropsProvider as C } from "@made-people/managed-props";
import { flattener as p } from "@made-people/flatten-object";
import { createEventEmitter as y } from "@made-people/grease-event-emitter";
function h(e) {
  const t = e.getFeatures();
  return Object.keys(t).sort().map((a) => {
    var i;
    return {
      featureId: a,
      value: e.getFeatureValue(
        a,
        (i = t[a]) == null ? void 0 : i.defaultValue
      )
    };
  });
}
const g = v(void 0), N = (e) => {
  const t = b(), a = w(
    () => e.activeFeatures ?? h(t),
    [t]
  ), [i, n] = m(a);
  return d(() => {
    const r = t.subscribe(() => {
      n((o) => {
        const u = h(t);
        return I(o, u) ? o : u;
      });
    });
    return () => r == null ? void 0 : r();
  }, [t]), /* @__PURE__ */ s(g.Provider, { value: i, children: e.children });
}, D = () => k(g);
function I(e, t) {
  var a, i, n, r;
  if (e === t)
    return !0;
  if (!e || !t || e.length !== t.length)
    return !1;
  for (let o = 0; o < e.length; o++)
    if (((a = e[o]) == null ? void 0 : a.featureId) !== ((i = t[o]) == null ? void 0 : i.featureId) || !Object.is((n = e[o]) == null ? void 0 : n.value, (r = t[o]) == null ? void 0 : r.value))
      return !1;
  return !0;
}
const G = v(void 0), V = (e) => /* @__PURE__ */ s(
  G.Provider,
  {
    value: e.viewedExperiments,
    children: e.children
  }
);
function O() {
  return k(G);
}
function A(e, t) {
  const [a, i] = m(
    t
  );
  return d(() => {
    i(t);
  }, [t]), d(() => {
    if (e)
      return e.subscribe((n, r) => {
        i((o) => {
          if (r.inExperiment)
            return {
              ...o,
              [n.key]: r.key
            };
          if (!o || !(n.key in o))
            return o;
          const u = { ...o };
          return delete u[n.key], u;
        });
      });
  }, [e]), a;
}
const M = (e) => {
  const t = w(() => {
    if (e.client)
      return e.client;
    if (!e.payload)
      throw new Error(
        "GreaseGrowthbookClientProvider: You must provide either a client or payload"
      );
    const i = [], n = e.attributes ?? {};
    if (typeof document < "u") {
      const r = e.cookieName ?? "gbuuid", o = document.cookie.split("; ").find((c) => c.startsWith(r + "=")), u = o ? (
        // @ts-expect-error - TS doesn't know that match is not undefined
        decodeURIComponent(o.split("=")[1])
      ) : null;
      n.id = u;
    }
    return new F({
      ...e.clientOptions,
      attributes: n,
      plugins: i
    }).initSync({
      payload: e.payload
    });
  }, [
    e.client,
    e.clientOptions,
    e.attributes,
    e.payload,
    e.cookieName
  ]), a = A(
    t,
    e.viewedExperiments
  );
  return d(() => {
    if (!t)
      return;
    const i = (n) => {
      const r = new URL(window.location.origin + n.to);
      t.setURL(r.toString()), t.setAttributes({
        ...t.getAttributes(),
        url: r.toString(),
        urlPathname: r.pathname
      });
    };
    return f.on("routeChanged", (n) => i(n)), () => {
      f.off("routeChanged", (n) => i(n));
    };
  }, [t]), /* @__PURE__ */ s(E, { growthbook: t, children: /* @__PURE__ */ s(
    V,
    {
      viewedExperiments: a,
      children: e.children
    }
  ) });
};
function _() {
  try {
    return b();
  } catch {
    return;
  }
}
function z(e, t) {
  try {
    return x(e, t);
  } catch {
    return;
  }
}
const H = (e) => {
  const t = O();
  return e.forceDisplay === !0 || t && t[e.experimentId] === e.variationId ? e.children : null;
};
function j(e, t) {
  const a = p(t.propDelimiter), n = e.filter(
    (r) => r.featureId.includes(t.componentNameDelimiter)
  ).reduce(
    (r, o) => {
      const [u, c] = o.featureId.split(
        t.componentNameDelimiter
      );
      return u && c && (r[u] || (r[u] = {}), r[u][c] = o.value), r;
    },
    {}
  );
  return Object.fromEntries(
    Object.entries(n).map(([r, o]) => {
      const u = a.unflatten(o);
      return [r, u];
    })
  );
}
const S = (e) => {
  var u, c;
  const t = D(), [a, i] = m(
    (e.deferredComponentNames ?? []).reduce((l, P) => (l[P] = null, l), {})
  ), n = e.componentNameDelimiter ?? "::", r = e.propDelimiter ?? "_";
  d(() => {
    if (t != null && t.length) {
      const l = j(t, {
        componentNameDelimiter: n,
        propDelimiter: r
      });
      i(l);
    }
  }, [t]);
  const o = {
    fallbackProps: (u = e.managedProps) == null ? void 0 : u.fallbackProps,
    overrideProps: (c = e.managedProps) == null ? void 0 : c.overrideProps,
    deferredOverrideProps: a
  };
  return /* @__PURE__ */ s(C, { value: o, children: e.children });
}, J = (e) => /* @__PURE__ */ s(M, { ...e.clientProviderProps, children: /* @__PURE__ */ s(
  N,
  {
    ...e.activeFeaturesProviderProps,
    children: /* @__PURE__ */ s(
      S,
      {
        deferredComponentNames: e.deferredComponentNames,
        managedProps: e.managedProps,
        children: e.children
      }
    )
  }
) }), K = y();
export {
  N as GreaseGrowthbookActiveFeaturesProvider,
  M as GreaseGrowthbookClientProvider,
  H as GreaseGrowthbookExperimentContainer,
  S as GreaseGrowthbookManagedPropsProvider,
  J as GreaseGrowthbookProvider,
  V as GreaseGrowthbookViewedExperimentsProvider,
  h as getGrowthbookFeaturesFromClient,
  K as greaseGrowthbookEventEmitter,
  g as growthbookActiveFeaturesContext,
  j as resolveGrowthbookManagedProps,
  _ as useGreaseGrowthbook,
  D as useGreaseGrowthbookActiveFeatures,
  z as useGreaseGrowthbookFeatureValue,
  O as useGreaseGrowthbookViewedExperiments,
  A as useGreaseGrowthbookViewedExperimentsState
};
//# sourceMappingURL=lib.es.js.map
